"use client";

import { useEffect } from "react";

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
	useEffect(() => {
		console.error(error);
	}, [error]);

	return (
		<div className="flex min-h-[70vh] items-center justify-center bg-bone px-5 py-16 text-mg-black">
			<div className="mx-auto max-w-prose text-center">
				<p className="mb-5 font-sans text-xs uppercase tracking-[0.18em] text-ink-muted">
					Something went wrong
				</p>
				<h1 className="font-serif text-4xl font-light leading-tight text-mg-black">
					A momentary distortion.
				</h1>
				<p className="mt-6 text-sm leading-relaxed text-ink-muted">
					Something didn&apos;t resolve as it should. Please try again.
				</p>
				<button
					className="mt-8 bg-mg-black px-7 py-3.5 font-sans text-xs uppercase tracking-[0.18em] text-bone transition-colors duration-300 hover:bg-mg-gold hover:text-mg-black"
					onClick={() => reset()}
				>
					Try again
				</button>
			</div>
		</div>
	);
}
